import React, { useState, useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";

const KindFoodNavDetail = ({
  kind,
  storedId,
  clickHandler,
  active,
  setActive,
}) => {
  return (
    <>
      {active !== kind.idNmae && (
        <li
          id={`section${kind.idNmae}`}
          className={
            active === kind.idNmae
              ? "black scroll-mt-36 color-section my-yellow-bg px-4 rounded-full "
              : "color-section bg-gray-100 whitespace-nowrap px-4 rounded-full "
          }
          onClick={() => clickHandler(kind.idNmae)}
        >
          <a
            
            // onClick={()=>clickHandler(kind)}
            // className={active === kind ? 'text-white': ''}

            href={`#${kind.idNmae}`}
          >
            {kind.title}
          </a>
        </li>
      )}
      {active === kind.idNmae && (
        <li
          id={`section${kind.idNmae}`}
          className={
            active === kind.idNmae
              ? "text-black whitespace-nowrap scroll-mt-36 color-section my-yellow-bg px-4 rounded-full "
              : "color-section bg-gray-100 px-4 rounded-full "
          }
          // onClick={() => clickHandler(kind.idNmae)}
        >
          <a
            
            // onClick={()=>clickHandler(kind)}
            // className={active === kind ? 'text-white': ''}

            
          >
            {kind.title}
          </a>
        </li>
      )}
    </>
  );
};

export default KindFoodNavDetail;
